import React, { useEffect, useState, useCallback, useRef } from 'react';
import Breadcrumbs from '../../components/BreadCrumbs';
import Card from '../../components/cards/Card';
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import SearchBar from '../../components/searchBar/SearchBar';
import Dropdown from '../../components/inputFields/DropDown';
import DateRangePicker from '../../components/inputFields/DateRangePicker';
import { Link } from 'react-router-dom';
import Button from '../../components/buttons/Button';
import Table from '../../components/tables/Table';
import Pagination from '../../components/tables/pagination/Pagination';
import CustomLoading from '../../components/customLoading/CustomLoading';
import { getOrders, patchOrder } from '../../services/orders';
import { toast } from 'react-toastify';
import { GrOrderedList } from 'react-icons/gr';
import { MdPayments } from 'react-icons/md';
import { BiCopy, BiRefresh } from 'react-icons/bi';
import ShowModal from '../../utils/ShowModal';
import OrderOrdersPopView from './OrderOrdersPopView';
import OrderPaymentsPopView from './OrderPaymentsPopView';
import { FaTruck } from 'react-icons/fa';
import OrderOrdersDetailsPopView from './OrderOrdersDetailsPopView';
import { GoEye } from 'react-icons/go';
import axios from 'axios';

function EcomEnquiries() {
    const [modalIsPaymentOpen, setIsPaymentOpen] = useState(false);
    const [modalIsOrderOpen, setIsOrderOpen] = useState(false);
    const [modalIsOrderDetailsOpen, setIsOrderDetailsOpen] = useState(false);
    const [openingItem, setOpeningItem] = useState({});



    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const headers = [
        { label: "ID", key: "id" },
        { label: "Date", key: "created_at" },
        { label: "Name", key: "name" },
        { label: "Phone", key: "number" },
        { label: "Ord. St.", key: "status" },
        { label: "Platform", key: "platform" },
        { label: "Order Value", key: "price" },
        { label: "Pay. St.", key: "payment_status" },
        { label: "Due Payment", key: "remaining_payment" },
        { label: "Pay. His.", key: "payment" },
        { label: "Ord. It.", key: "order_item" },
        { label: "Logi.", key: "logi" },
        { label: "View", key: "view" },
    ];

    const [searchText, setSearchText] = useState("");
    const [debouncedSearchText, setDebouncedSearchText] = useState("");
    const [paymentFilterStatus, setPaymentFilterStatus] = useState("");
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    const todayStr = `${yyyy}-${mm}-${dd}`;
    const firstDayOfMonth = `${yyyy}-${mm}-01`;
    const [filterDate, setFilterDate] = useState({ start: firstDayOfMonth, end: todayStr });

    const pageSize = 10;
    const cancelTokenRef = useRef(null);
    const searchTimeoutRef = useRef(null);

    // Always filter by PENDING status
    const FIXED_STATUS = 'PENDING';

    // Debounce search input (300ms delay)
    useEffect(() => {
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }

        searchTimeoutRef.current = setTimeout(() => {
            setDebouncedSearchText(searchText);
        }, 300);

        return () => {
            if (searchTimeoutRef.current) {
                clearTimeout(searchTimeoutRef.current);
            }
        };
    }, [searchText]);

    // Centralized query builder function
    const buildQueryString = useCallback((overrides = {}) => {
        const params = new URLSearchParams();

        const search = overrides.search !== undefined ? overrides.search : debouncedSearchText;
        const paymentStatus = overrides.payment_status !== undefined ? overrides.payment_status : paymentFilterStatus;
        const dateStart = overrides.start_date !== undefined ? overrides.start_date : filterDate.start;
        const dateEnd = overrides.end_date !== undefined ? overrides.end_date : filterDate.end;

        if (search) params.append('search', search);
        if (paymentStatus) params.append('payment_status', paymentStatus);
        // Always add PENDING status filter
        params.append('status', FIXED_STATUS);
        if (dateStart) params.append('start_date', dateStart);
        if (dateEnd) params.append('end_date', dateEnd);
        params.append('order_type', 'B2C');

        return `?${params.toString()}`;
    }, [debouncedSearchText, paymentFilterStatus, filterDate]);

    const handleSearch = useCallback((query) => {
        setSearchText(query);
    }, []);

    const handlePageChange = useCallback((page) => {
        setCurrentPage(page);
    }, []);

    const handlePaymentStatusChange = useCallback((value) => {
        setPaymentFilterStatus(value);
    }, []);

    const handleDateChange = useCallback((value) => {
        setFilterDate(value);
    }, []);

    const fetchData = useCallback(async (query) => {
        if (cancelTokenRef.current) {
            cancelTokenRef.current.cancel('Operation canceled due to new request');
        }

        cancelTokenRef.current = axios.CancelToken.source();

        setLoading(true);
        try {
            let res = await getOrders(query, {
                cancelToken: cancelTokenRef.current.token
            });
            if (res.status === 200) {
                const data = res.data;
                setData(data);
            } else {
                toast.error("Unable to fetch Data");
            }
        } catch (error) {
            if (axios.isCancel(error)) {
                console.log('Request canceled:', error.message);
            } else {
                console.error("Error in EcomEnquiries:", error);
                toast.error("Unable to fetch Data");
            }
        } finally {
            setLoading(false);
        }
    }, []);



    const openPaymentModal = (item) => {
        setOpeningItem(item);
        setIsPaymentOpen(true);
    };

    const closePaymentModal = useCallback(() => {
        setIsPaymentOpen(false);
        setOpeningItem({});
    }, []);

    const openOrdersModal = (item) => {
        setOpeningItem(item);
        setIsOrderOpen(true);
    };

    const closeOrdersModal = () => {
        setIsOrderOpen(false);
        setOpeningItem({});
    };

    const openDetailsModal = (item) => {
        setOpeningItem(item);
        setIsOrderDetailsOpen(true);
    };

    const closeDetailsModal = () => {
        setIsOrderDetailsOpen(false);
        setOpeningItem({});
    };

    const handleRowStatusChange = useCallback(async (item, value) => {
        try {
            const data = { status: value };
            let res = await patchOrder({ data: data, id: item.id });
            if (res.status === 200) {
                toast.success("Status Updated");
                fetchData(buildQueryString());
            } else {
                toast.error("Unable to Update Status");
            }
        } catch (error) {
            console.error("Error in EcomEnquiries:", error);
            toast.error("Unable to Update Status");
        }
    }, [fetchData, buildQueryString]);

    const onPaymentSave = useCallback(async () => {
        closePaymentModal();
        fetchData(buildQueryString());
    }, [fetchData, buildQueryString, closePaymentModal]);

    const copyClipboard = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => { toast.success('Copied to clipboard!'); })
            .catch(() => { toast.error('Failed to copy address'); });
    };

    const resetFilters = useCallback(() => {
        setSearchText("");
        setDebouncedSearchText("");
        setFilterDate({ start: null, end: null });
        setPaymentFilterStatus("");
    }, []);

    // Fetch data when filters change
    useEffect(() => {
        const query = buildQueryString();
        fetchData(query);
    }, [debouncedSearchText, paymentFilterStatus, filterDate.start, filterDate.end, buildQueryString, fetchData]);



    // Reset to first page when filters change
    useEffect(() => {
        setCurrentPage(1);
    }, [debouncedSearchText, paymentFilterStatus, filterDate.start, filterDate.end]);

    const tableRows = data?.results?.map((item, index) => ({
        id: <span className='flex flex-row gap-1 items-center'><p className="max-w-16 truncate cursor-help" title={item.id}>{item.id}</p> <BiCopy className='cursor-pointer' color='blue' onClick={() => { copyClipboard(item.id) }} /></span>,
        created_at: <p>{item.order_date}</p>,
        name: <p>{item.user}</p>,
        number: <p>{item.phone_number}</p>,
        payment_status: <p className={`${item.payment_status === "COMPLETED" ? "bg-primary" : item.payment_status === "PENDING" ? "bg-red-600" : "bg-yellow-300"} px-2 py-1 rounded-full text-center text-white font-bold text-[0.5rem]`}>{item.payment_status === "PARTIAL PAYMENT" ? "PART" : item.payment_status}</p>,
        remaining_payment: <p>₹{item.remaining_payment}</p>,
        status: <Dropdown
            name="status"
            options={[
                { label: "Pending", value: "PENDING" },
                { label: "Confirmed", value: "CONFIRMED" },
                { label: "Packaging", value: "IN_PACKAGING" },
                { label: "Dispatched", value: "DISPATCHED" },
                { label: "Delivered", value: "DELIVERED" },
                { label: "Cancelled", value: "CANCELLED" },
            ]}
            placeholder={item.status}
            onChange={(value) => handleRowStatusChange(item, value)}
        />,
        platform: <p>{item.platform}</p>,
        price: <p>₹{item.total_price}</p>,
        address: <span className='flex flex-row gap-1 items-center'><p className="max-w-16 truncate cursor-help" title={item.shipping_user?.shipping_address}>{item.shipping_user?.shipping_address}</p> <BiCopy className='cursor-pointer' color='blue' onClick={() => { copyClipboard(item.shipping_user?.shipping_address) }} /></span>,
        payment: <div className="flex flex-row justify-center"><MdPayments size={24} color='green' className='cursor-pointer' onClick={() => { openPaymentModal(item) }} /></div>,
        order_item: <div className="flex flex-row justify-center"><GrOrderedList size={24} color='blue' className='cursor-pointer' onClick={() => { openOrdersModal(item) }} /></div>,
        logi: <Link to={`/shipments/add/`} state={item}><FaTruck size={20} className='text-blue-950 cursor-pointer' /></Link>,
        view: <div className="flex flex-row justify-center"><GoEye size={24} color='purple' className='cursor-pointer' onClick={() => { openDetailsModal(item) }} /></div>,
    }));

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/dashboard' },
            { name: 'Ecom Enquiries' },
        ]} />
        <div className="py-3">
            <StyledHeadingText text={"Ecom Enquiries"} />
            <div className="mt-2">
                <Card title={"Total Pending Orders"} count={data?.count ?? 0} />
            </div>
        </div>

        {/* Pending badge */}
        <div className="flex items-center gap-2 mb-3">
            <span className="bg-red-100 text-red-700 text-xs font-semibold px-3 py-1 rounded-full border border-red-300">
                🕐 Pending Orders
            </span>
            <span className="text-xs text-gray-500">Showing all orders with status: Pending</span>
        </div>

        <div className="flex flex-row justify-between item-center">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 justify-center items-center max-w-4xl">
                <SearchBar placeholder="Search for Order ID / Farmer Name" onSearch={handleSearch} value={searchText} />
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-4 justify-center items-center">
                    <Dropdown
                        name="status"
                        options={[
                            { label: "— All —", value: "" },
                            { label: "Completed", value: "COMPLETED" },
                            { label: "Pending", value: "PENDING" },
                        ]}
                        value={paymentFilterStatus}
                        placeholder={"Payment Status"}
                        onChange={handlePaymentStatusChange}
                    />
                    <div className="flex flex-row items-center gap-2">
                        <DateRangePicker
                            value={filterDate}
                            onChange={handleDateChange}
                            placeholder="Date Range"
                            className="w-full"
                        />
                        {
                            searchText.length !== 0 || paymentFilterStatus !== "" || filterDate.start !== null || filterDate.end !== null ?
                                <BiRefresh size={24} className='cursor-pointer text-primary' onClick={resetFilters} /> : <></>
                        }
                    </div>
                </div>
            </div>

        </div>

        <div className="mt-4">
            {loading ? (
                <div className="flex w-full flex-row justify-center my-2">
                    <CustomLoading size={100} />
                </div>
            ) : (
                <div className="mt-2">
                    <Table headers={headers} rows={tableRows} />
                </div>
            )}
            {data.count !== 0 ? (
                <Pagination
                    currentPage={currentPage}
                    pageSize={pageSize}
                    totalEntries={data?.count}
                    onPageChange={handlePageChange}
                    data={data}
                    setData={setData}
                />
            ) : <></>}
        </div>

        <ShowModal contentLabel={"Payment alert"} isOpen={modalIsPaymentOpen} modalWidth="50%" isSidebar={true} onRequestClose={closePaymentModal} componentToPass={<OrderPaymentsPopView item={openingItem} onOperation={() => onPaymentSave()} />} />
        <ShowModal contentLabel={"Orders alert"} isOpen={modalIsOrderOpen} modalWidth="50%" isSidebar={true} onRequestClose={closeOrdersModal} componentToPass={<OrderOrdersPopView item={openingItem} onOperation={() => { closeOrdersModal(); fetchData(buildQueryString()); }} />} />
        <ShowModal contentLabel={"Order Details alert"} isOpen={modalIsOrderDetailsOpen} modalWidth="50%" isSidebar={true} onRequestClose={closeDetailsModal} componentToPass={<OrderOrdersDetailsPopView item={openingItem} onListRefresh={() => fetchData(buildQueryString())} />} />
    </>);
}

export default EcomEnquiries;
